import { useMemo } from 'react'
import { useGetIntakeforms } from '@/api/generated/intake-form-template/intake-form-template'
import { extractIntakeFormsList } from './extractIntakeFormsList'

/**
 * Shared intake-form-template read.
 *
 * Replaces the `getIntakeForms` thunk and the `newService.intakeForms` selector that both
 * new-service and view-service consumed. Both pages now read from one React Query cache.
 * Returns the list under `intakeForms` to match the field the consuming forms expect.
 *
 * The backend returns an `{ IntakeForms: [...] }` wrapper even though the generated contract
 * types a bare array, so we normalize via `extractIntakeFormsList` (same as `useIntakeForms`)
 * to avoid `intakeForms.map is not a function`.
 */
export const useIntakeFormTemplates = () => {
  const query = useGetIntakeforms()
  const intakeForms = useMemo(() => extractIntakeFormsList(query.data), [query.data])

  return { ...query, intakeForms }
}
